import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Phone } from "./../../assets/svg/phone-call.svg";
import { ReactComponent as Mail } from "./../../assets/svg/unread-email.svg";
import { ReactComponent as Instagram } from "./../../assets/svg/instagram.svg";
import { ReactComponent as Telegram } from "./../../assets/svg/telegram.svg";
import { ReactComponent as Linkdin } from "./../../assets/svg/linkedin.svg";
import { ReactComponent as Address } from "./../../assets/svg/address.svg";
import { ReactComponent as Support } from "./../../assets/svg/24-hours-support.svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("common");
  return (
    <footer className="footer-distributed">
      <div className="footer-left">
        <h3>
          Bell&nbsp;
          <span>Meet</span>
        </h3>

        <p className="footer-links">
          <Link to={"/"}>{t("Home")}</Link>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Link to={"/price"}>{t("Plans")}</Link>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {t("lang") === "fa" ? (
            <Link to={"/support"}>{t("Support")}</Link>
          ) : (
            <Link to={"/videoEn"}>{t("Support")}</Link>
          )}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {t("lang") === "fa" ? (
            <Link to={"/support/faq"}>
              سوالات متداول &nbsp;&nbsp;&nbsp;&nbsp;
            </Link>
          ) : (
            ""
          )}
          <a href="https://blog.bellmeet.com">{t("Blog")}</a>
        </p>

        <div className="footer-icons">
          <a href="https://instagram.com/bellmeet.online">
            <Instagram />
          </a>
          <a href="https://telegram.me/BellMeet">
            <Telegram />
          </a>
          <a href="https://www.linkedin.com/in/bellmeet">
            <Linkdin />
          </a>
          <a href="mailto:info@bellmeet.com">
            <Mail />
          </a>
        </div>
      </div>

      <div className="footer-center">
        <span>{t("ContactUs")}</span>
        <div className="footer-address">
          <Address />
          <p>{t("Address")}</p>
        </div>
        {/*<div className="footer-phone">*/}
        {/*    <Phone/>*/}
        {/*    <p>021-22643814</p>*/}
        {/*</div>*/}
        <div className="footer-support">
          <Support />
          <p>021-26297306</p>
        </div>
        <br />
        {/*<div className="footer-email">
                <Email/>
              <p><a href="mailto:info@bellmeet.com">info@Bellmeet.com</a></p>
            </div>*/}
      </div>

      <div className="footer-right">
        <p className="footer-company-about">
          <span>{t("AboutUs")}</span>
          {t("BllMeetcompany")}
        </p>
      </div>
      <div className="namadha">
        <a
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=220461&Code=CA03nPf5tfIrBsnzipUO"
        >
          <img
            referrerpolicy="origin"
            src="https://trustseal.enamad.ir/logo.aspx?id=220461&Code=CA03nPf5tfIrBsnzipUO"
            alt=""
            code="CA03nPf5tfIrBsnzipUO"
          />
        </a>
        {/* <img
          id="nbqergvjfukzwlaojzpeoeuk"
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.open(
              "https://logo.samandehi.ir/Verify.aspx?id=249977&p=uiwkaodspfvlpfvljyoejyoe",
              "Popup",
              "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
            );
          }}
          alt="logo-samandehi"
          src="https://logo.samandehi.ir/logo.aspx?id=249977&p=odrfshwlbsiybsiyyndtyndt"
        />
        <img
          id="nbqergvjfukzwlaojzpeoeuk"
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.open(
              "https://ecunion.ir/verify/bellmeet.com?token=233157960e9664ae98d1",
              "Popup",
              "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
            );
          }}
          alt="logo-majazi"
          src="https://bellmeet.com/helpvideo/majazi.png"
        /> */}
      </div>
      <div id="copyright">
        <p>© Bellmeet {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
